import Cookies from 'universal-cookie';
import { WEBSITE_DOMAIN } from 'enviroments';

const cookies = new Cookies();
const current = new Date();
const nextYear = new Date();

nextYear.setFullYear(current.getFullYear() + 1);

const _setToken = (token: string) => {
  cookies.set('access_token', token, {
    path: `/`,
    expires: nextYear,
    domain: WEBSITE_DOMAIN
  });
};

const _getToken = () => {
  const data = cookies.get('access_token');
  return data;
};

const _removeToken = () => {
  cookies.remove('access_token', { path: '/', domain: WEBSITE_DOMAIN });
};

export { _setToken, _getToken, _removeToken };
